import rules from "../../rules";

const LEGACY_MAP = {
	"contacts-page:deleteContact": "contacts:delete",
	"ticket-options:deleteTicket": "tickets:delete",
	"ticket-options:transferWhatsapp": "tickets:transfer",
	"ticket-options:replay": "supervision:replay",
	"tickets-manager:showall": "tickets:viewAll",
	"user-modal:editProfile": "users:edit",
	"user-modal:editQueues": "users:edit",
};

export const hasPermission = (userOrRole, action) => {
	if (!userOrRole) return false;

	if (typeof userOrRole === "object") {
		const user = userOrRole;
		if (user.profile === "admin") return true;

		const rbacKey = LEGACY_MAP[action] || action;

		if (Array.isArray(user.permissions)) {
			return user.permissions.includes(rbacKey);
		}

		const roleStr = user.profile || "user";
		const permissions = rules[roleStr];
		return Boolean(permissions?.static?.includes(action));
	}

	const roleStr = String(userOrRole);
	if (roleStr === "admin") return true;

	const permissions = rules[roleStr];
	return Boolean(permissions?.static?.includes(action));
};

const Can = ({ user, role, perform, data, yes = () => null, no = () => null }) => {
	const subject = user || role;
	return hasPermission(subject, perform, data) ? yes() : no();
};

export { Can };
